import { forwardRef, memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

import HistoryCard from "../../components/about/historyCard/history-card";
import { HistorySidebar } from "../../components/about/historyCard";
import clsx from "clsx";

gsap.registerPlugin(ScrollTrigger);

// eslint-disable-next-line react/display-name
const HistoryArea = forwardRef(({ dataList }, ref) => {
  const gsapContainer = useRef();
  const [listAnimStatus, setListAnimStatus] = useState([]);

  const handleRefreshScrollTrigger = () => {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 0);
  };

  useGSAP(
    () => {
      dataList.forEach((element, index) => {
        gsap.fromTo(
          `.history-container-${index} .fade-in-anim`,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
              onEnter: (self) => {
                const index = Number(self.trigger.getAttribute("data-anim-index"));
                setListAnimStatus((prev) => prev.map((item, i) => (i === index ? true : item)));
              },
              onEnterBack: (self) => {
                const index = Number(self.trigger.getAttribute("data-anim-index"));
                setListAnimStatus((prev) => prev.map((item, i) => (i === index ? true : item)));
              },
              trigger: `.history-container-${index}`,
              start: "top center",
              toggleActions: "play none none", // 在元素進入視窗時播放動畫，在元素離開視窗時重置動畫
            },
          }
        );
      });
    },
    { scope: gsapContainer }
  );

  useEffect(() => {
    setListAnimStatus(Array.from({ length: dataList.length }).fill(false));
    handleRefreshScrollTrigger();
  }, [dataList]);

  return (
    <div ref={gsapContainer} className="root">
      <div className="history-start">
        <img
          className="history-title"
          src="./asset/image/about/history-start.png"
          alt="history-start"
        />
      </div>
      <div>
        {dataList &&
          dataList.map((item, index) => (
            <div
              data-anim-index={index}
              key={item.id}
              className={clsx("history-container", `history-container-${index}`)}
            >
              <HistorySidebar />
              <HistoryCard animActive={listAnimStatus[index]} {...item} />
            </div>
          ))}
      </div>
    </div>
  );
});

export default memo(HistoryArea);

HistoryArea.propTypes = {
  dataList: PropTypes.array,
};
